import Layout from '@layout/Index'

export const workbench = [
  {
    path: '/workbench',
    component: Layout,
    children: [
      {
        path: '',
        component: () => import(/* webpackChunkName: "workbench" */ './pages/Workbench.vue'),
        name: '工作台',
        meta: {
          title: '工作台'
        }
      },
      {
        path: 'attendance-plan',
        component: () => import(/* webpackChunkName: "workbench" */ './pages/AttendancePlan.vue'),
        name: '出勤设置',
        meta: {
          title: '出勤设置'
        }
      }
    ]
  }
]



// WEBPACK FOOTER //
// ./src/views/workbench/workbench.route.js